/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NoPermissionRouteImport } from './routes/no-permission'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CoolingRegimesProductGroupRouteImport } from './routes/cooling-regimes-product-group'
import { Route as CoolingRegimesRouteImport } from './routes/cooling-regimes'
import { Route as ClaimsRouteImport } from './routes/claims'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as ProductsRouteRouteImport } from './routes/products/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CoolingRegimesProductGroupIdRouteImport } from './routes/cooling-regimes-product-group.$id'
import { Route as ProductsIdRouteRouteImport } from './routes/products/$id/route'

const NoPermissionRoute = NoPermissionRouteImport.update({
  id: '/no-permission',
  path: '/no-permission',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CoolingRegimesProductGroupRoute =
  CoolingRegimesProductGroupRouteImport.update({
    id: '/cooling-regimes-product-group',
    path: '/cooling-regimes-product-group',
    getParentRoute: () => rootRouteImport,
  } as any)
const CoolingRegimesRoute = CoolingRegimesRouteImport.update({
  id: '/cooling-regimes',
  path: '/cooling-regimes',
  getParentRoute: () => rootRouteImport,
} as any)
const ClaimsRoute = ClaimsRouteImport.update({
  id: '/claims',
  path: '/claims',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRouteRoute = ProductsRouteRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CoolingRegimesProductGroupIdRoute =
  CoolingRegimesProductGroupIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => CoolingRegimesProductGroupRoute,
  } as any)
const ProductsIdRouteRoute = ProductsIdRouteRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ProductsRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/products': typeof ProductsRouteRouteWithChildren
  '/callback': typeof CallbackRoute
  '/claims': typeof ClaimsRoute
  '/cooling-regimes': typeof CoolingRegimesRoute
  '/cooling-regimes-product-group': typeof CoolingRegimesProductGroupRouteWithChildren
  '/login': typeof LoginRoute
  '/no-permission': typeof NoPermissionRoute
  '/products/$id': typeof ProductsIdRouteRoute
  '/cooling-regimes-product-group/$id': typeof CoolingRegimesProductGroupIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/products': typeof ProductsRouteRouteWithChildren
  '/callback': typeof CallbackRoute
  '/claims': typeof ClaimsRoute
  '/cooling-regimes': typeof CoolingRegimesRoute
  '/cooling-regimes-product-group': typeof CoolingRegimesProductGroupRouteWithChildren
  '/login': typeof LoginRoute
  '/no-permission': typeof NoPermissionRoute
  '/products/$id': typeof ProductsIdRouteRoute
  '/cooling-regimes-product-group/$id': typeof CoolingRegimesProductGroupIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/products': typeof ProductsRouteRouteWithChildren
  '/callback': typeof CallbackRoute
  '/claims': typeof ClaimsRoute
  '/cooling-regimes': typeof CoolingRegimesRoute
  '/cooling-regimes-product-group': typeof CoolingRegimesProductGroupRouteWithChildren
  '/login': typeof LoginRoute
  '/no-permission': typeof NoPermissionRoute
  '/products/$id': typeof ProductsIdRouteRoute
  '/cooling-regimes-product-group/$id': typeof CoolingRegimesProductGroupIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/products'
    | '/callback'
    | '/claims'
    | '/cooling-regimes'
    | '/cooling-regimes-product-group'
    | '/login'
    | '/no-permission'
    | '/products/$id'
    | '/cooling-regimes-product-group/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/products'
    | '/callback'
    | '/claims'
    | '/cooling-regimes'
    | '/cooling-regimes-product-group'
    | '/login'
    | '/no-permission'
    | '/products/$id'
    | '/cooling-regimes-product-group/$id'
  id:
    | '__root__'
    | '/'
    | '/products'
    | '/callback'
    | '/claims'
    | '/cooling-regimes'
    | '/cooling-regimes-product-group'
    | '/login'
    | '/no-permission'
    | '/products/$id'
    | '/cooling-regimes-product-group/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProductsRouteRoute: typeof ProductsRouteRouteWithChildren
  CallbackRoute: typeof CallbackRoute
  ClaimsRoute: typeof ClaimsRoute
  CoolingRegimesRoute: typeof CoolingRegimesRoute
  CoolingRegimesProductGroupRoute: typeof CoolingRegimesProductGroupRouteWithChildren
  LoginRoute: typeof LoginRoute
  NoPermissionRoute: typeof NoPermissionRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/no-permission': {
      id: '/no-permission'
      path: '/no-permission'
      fullPath: '/no-permission'
      preLoaderRoute: typeof NoPermissionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cooling-regimes-product-group': {
      id: '/cooling-regimes-product-group'
      path: '/cooling-regimes-product-group'
      fullPath: '/cooling-regimes-product-group'
      preLoaderRoute: typeof CoolingRegimesProductGroupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cooling-regimes': {
      id: '/cooling-regimes'
      path: '/cooling-regimes'
      fullPath: '/cooling-regimes'
      preLoaderRoute: typeof CoolingRegimesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/claims': {
      id: '/claims'
      path: '/claims'
      fullPath: '/claims'
      preLoaderRoute: typeof ClaimsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cooling-regimes-product-group/$id': {
      id: '/cooling-regimes-product-group/$id'
      path: '/$id'
      fullPath: '/cooling-regimes-product-group/$id'
      preLoaderRoute: typeof CoolingRegimesProductGroupIdRouteImport
      parentRoute: typeof CoolingRegimesProductGroupRoute
    }
    '/products/$id': {
      id: '/products/$id'
      path: '/$id'
      fullPath: '/products/$id'
      preLoaderRoute: typeof ProductsIdRouteRouteImport
      parentRoute: typeof ProductsRouteRoute
    }
  }
}

interface ProductsRouteRouteChildren {
  ProductsIdRouteRoute: typeof ProductsIdRouteRoute
}

const ProductsRouteRouteChildren: ProductsRouteRouteChildren = {
  ProductsIdRouteRoute: ProductsIdRouteRoute,
}

const ProductsRouteRouteWithChildren = ProductsRouteRoute._addFileChildren(
  ProductsRouteRouteChildren,
)

interface CoolingRegimesProductGroupRouteChildren {
  CoolingRegimesProductGroupIdRoute: typeof CoolingRegimesProductGroupIdRoute
}

const CoolingRegimesProductGroupRouteChildren: CoolingRegimesProductGroupRouteChildren =
  {
    CoolingRegimesProductGroupIdRoute: CoolingRegimesProductGroupIdRoute,
  }

const CoolingRegimesProductGroupRouteWithChildren =
  CoolingRegimesProductGroupRoute._addFileChildren(
    CoolingRegimesProductGroupRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProductsRouteRoute: ProductsRouteRouteWithChildren,
  CallbackRoute: CallbackRoute,
  ClaimsRoute: ClaimsRoute,
  CoolingRegimesRoute: CoolingRegimesRoute,
  CoolingRegimesProductGroupRoute: CoolingRegimesProductGroupRouteWithChildren,
  LoginRoute: LoginRoute,
  NoPermissionRoute: NoPermissionRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
